import { useCallback } from "react"
import { getMerchandisePartyTableList, geArrayByFieldName } from '@EUForms/utils'
import { initializeErrors, updateValidationErrors } from "../reducer/validationSlice"
import { fieldPatterns } from "../util/fieldPatterns"
import validate from "validate.js"
import { createValidationStructure } from "../../../../src/components/Helper"
import { validateInvoices } from "../util/itemsTabValidation"
import { 
    invoiceDataTransformation, 
    validateAddSupChainActorHeader, 
    validateAddSupplyChainActorItemsTab, 
    validateArrayObjectProperty, 
    validateMerchandiseActors
} from "../util/validateFunctions"



export const MERCH_ACTORS_TABLE = {
    consigneeList: { key: 'consigneeList', value: 'CONSIGNEE' },
    consignorsList: { key: 'consignorsList', value: 'CONSIGNOR' },
    authorizationsList: { key: 'authorizationsList', value: 'AUTHORIZATION' },
    additionalSupplyChainActorsList: { key: 'additionalSupplyChainActorsList', value: 'ADD_SUPPLY_CHAIN_ACTOR' },
}

const useValidationAES = (isImportShipment,translate) => {
    const initHeaderTabValidation = useCallback(() => (dispatch, getState) => {
        const headerTab = getState().headerReducer?.headerTab || {}
        const addSupplyChainActorList = getState()?.actorReducer?.additionalSupplyChainActorsList
        let headerTabErrors = validate(headerTab, fieldPatterns(isImportShipment,translate)()?.headerTab) || {}
        headerTabErrors = createValidationStructure(headerTabErrors) || {}
        const [errorKey, addSupplyChainActorListError] = validateAddSupChainActorHeader(addSupplyChainActorList,translate)
        dispatch(initializeErrors({ headerTab: {...headerTabErrors, ...addSupplyChainActorListError} }))
    }, [])

 
    const initHeaderTabAddSupChainActorValidation = useCallback((params = {}) => (dispatch, getState) => {
        const addSupplyChainActorList = getState()?.actorReducer?.additionalSupplyChainActorsList
        const [errorKey, errors] = validateAddSupChainActorHeader(addSupplyChainActorList)
        dispatch(updateValidationErrors({
            tabName: 'headerTab',
            errors: errors,
            errorKeys: [`${errorKey}`] // to be update
        }))
    }, [])

    const initItemsTabValidation = useCallback(() => (dispatch, getState) => {
        // ------------------------------ state getter ------------------------------
        const invoiceData = getState()?.invoiceReducer?.invoice
        const merchandiseMap = getState().invoiceReducer?.invoice?.merchandiseMap || {}
        const addSupplyChainActorListHeader = getState()?.actorReducer?.additionalSupplyChainActorsList || []
        // ------------------------------ core itemsTab validation start ------------------------------
        const invoiceDataTransformed = invoiceDataTransformation(invoiceData)
        const itemsTabErrors = validateInvoices(invoiceDataTransformed, fieldPatterns(isImportShipment,translate)()?.itemsTab, {addSupplyChainActorListHeader},translate)
        // ------------------------------ core itemsTab validation end ------------------------------
        // ------------------------------ merchandise parties actor validation start ------------------------------
        const consigneeEoriList = geArrayByFieldName(getMerchandisePartyTableList(merchandiseMap, 'consigneeList'), 'eoriNo')
        const consignorsEoriList = geArrayByFieldName(getMerchandisePartyTableList(merchandiseMap, 'consignorsList'), 'eoriNo')
        const merchandiseMapLength = Object.keys(merchandiseMap)?.length
        const errorConsignees = validateMerchandiseActors(consigneeEoriList, merchandiseMapLength, 'CONSIGNEE',translate)
        const errorConsignors = validateMerchandiseActors(consignorsEoriList, merchandiseMapLength, 'CONSIGNOR',translate)
        let merchPartiesActorErrors = {}
        if (errorConsignees || errorConsignors) {
            merchPartiesActorErrors = {
                'ALL-LINE-ITEMS_CONSIGNEE': { msg: [errorConsignees] },
                'ALL-LINE-ITEMS_CONSIGNOR': { msg: [errorConsignors] }
            }
        }
        // ------------------------------ merchandise parties actor validation end ------------------------------
        dispatch(initializeErrors({ itemsTab: { ...itemsTabErrors, ...merchPartiesActorErrors } }))
    }, [translate])

    const updateMerchActorsError = useCallback((tableName) => (dispatch, getState) => {
        const tabName = MERCH_ACTORS_TABLE[tableName]?.key, tabValue = MERCH_ACTORS_TABLE[tableName]?.value
        const merchandiseMap = getState().invoiceReducer?.invoice?.merchandiseMap || {}
        const actorEoriList = geArrayByFieldName(getMerchandisePartyTableList(merchandiseMap, tabName), 'eoriNo')

        const errorActor = validateMerchandiseActors(actorEoriList, Object.keys(merchandiseMap)?.length, tabValue)
        const errors = errorActor ? { [`ALL-LINE-ITEMS_${tabValue}`]: { msg: [errorActor] } } : {}
        dispatch(updateValidationErrors({
            tabName: 'itemsTab',
            errors: errors,
            errorKeys: [`ALL-LINE-ITEMS_${tabValue}`]
        }))
    }, [])

    const updateMerchActorsRoleTypeError = useCallback((params) => (dispatch, getState) => {
        const { containerKey = 'merchandiseParties', key, value, tableName, invoiceIndex, itemIndex, merchandiseId,translate } = params        
        const tabName = MERCH_ACTORS_TABLE[tableName]?.key, tabValue = MERCH_ACTORS_TABLE[tableName]?.value
        const addSupplyChainActorListHeader = getState()?.actorReducer?.additionalSupplyChainActorsList || []
        const addSupplyChainActorListItems = getState()?.invoiceReducer?.invoice?.merchandiseMap?.[merchandiseId][containerKey][tableName] || []
        
        const [errorKeys=[],addSupplyChainActorErrorsInContextOfHeader={}] = validateAddSupplyChainActorItemsTab({
            addSupplyChainActorListHeader:addSupplyChainActorListHeader,
            addSupplyChainActorListItems:addSupplyChainActorListItems, key, tabName, tabValue, invoiceIndex, itemIndex, translate
        })

        const isActorOfSameRoleOrType = addSupplyChainActorListItems?.length > 1 
        ? validateArrayObjectProperty(addSupplyChainActorListItems, key, value) : false
        
        const errorKey = `invoice${invoiceIndex + 1}_lineItem${itemIndex + 1}_${tabName}`
     
        const errors = isActorOfSameRoleOrType ? {
            [errorKey]: {
                msg: `${translate('INVOICE')} 00${invoiceIndex + 1} :: ${translate('LINEITEM')} 00${itemIndex + 1} :: ${translate('PARTIES')} :: ${translate(tabValue)} ::  ${translate('can_not_have_more_than_one')} ${translate(tabValue)} ${translate(key)} ${translate('of_same_value')}`
            }
        } : {}
        dispatch(updateValidationErrors({
            tabName: 'itemsTab',
            errors: {...errors,...addSupplyChainActorErrorsInContextOfHeader},
            errorKeys: [errorKey,...errorKeys]
        }))
    }, [])

    return {
        initItemsTabValidation,
        updateMerchActorsError,
        updateMerchActorsRoleTypeError,
        initHeaderTabValidation,
        initHeaderTabAddSupChainActorValidation
    }
}

export default useValidationAES
